import type { CategoryWebLink } from '../../types';
import { recursiveFormat } from '../helperFunctions';
import type { TransformedCmsConfigItemLevels } from '../types';

export const cmsConfigTransformer = (cmsConfig: CategoryWebLink) => {
    const config: TransformedCmsConfigItemLevels = {};
    cmsConfig.children?.forEach((child) => recursiveFormat(config, child, '0', 1));

    return config;
};
